"use strict";

var ParticulatesOpportunityLayer = function () {
  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    loadColumnArrayUpdatedListener(mapId);
    loadToggledListenerForMap(map, mapLayers, mapId);
    loadDataUpdatedListenerForMap(map, mapLayers, mapId);
    loadFiltersUpdatedListenerForMap(map, mapLayers, mapId);
  };

  var loadToggledListenerForMap = function (map, mapLayers, mapId) {
    MapFunctions.whenLayerToggled(
      mapId,
      "particulatesOpportunity",
      function (isEnabled, sameSpatialFilter, sameView, sameGroup) {
        var telrLayer = mapLayers.particulatesOpportunityLayer;
        var sameLayerDropdown =
          Tree.get("layers", mapId, "particulatesOpportunity", "layerDropdown") ===
          Tree.get("layerDropdown", mapId);
        var forceRefresh = !sameView || !sameLayerDropdown || !sameGroup;
        if (isEnabled) {
          TelrLayerFunctions.displayTelrLayer(
            telrLayer,
            "particulatesOpportunity",
            "particulateRate",
            map,
            mapLayers,
            forceRefresh,
          );
        } else {
          if (MapFunctions.mapHasLayer(map, telrLayer)) {
            map.removeLayer(telrLayer);
          }
        }
      },
    );
  };

  var loadDataUpdatedListenerForMap = function (map, mapLayers, mapId) {
    MapFunctions.whenLayerDataUpdated(Tree, mapId, "particulatesOpportunity", function (data) {
      mapLayers.particulatesOpportunityLayer = addParticulatesOpportunityLayer(
        map,
        mapLayers.particulatesOpportunityLayer,
        data,
      );
      TelrLayerFunctions.selectTelrCatchmentsByFilter(mapLayers.particulatesOpportunityLayer);
      if (
        Tree.get("layers", mapId, "catchments", "isEnabled") &&
        !Tree.get("layers", mapId, "catchments", "isFetching")
      ) {
        Table.render();
      }
    });
  };

  var addParticulatesOpportunityLayer = function (map, particulatesOpportunityLayer, layerData) {
    if (particulatesOpportunityLayer) {
      map.removeLayer(particulatesOpportunityLayer);
    }
    particulatesOpportunityLayer = new (Layers.getLayers().ParticulatesLayer)(layerData).addTo(map);
    return particulatesOpportunityLayer;
  };

  var loadFiltersUpdatedListenerForMap = function (map, mapLayers, mapId) {};

  var loadColumnArrayUpdatedListener = function (mapId) {
    Tree.select(["layers", mapId, "particulatesOpportunity", "columnArray"]).on(
      "update",
      function (e) {
        const DataViewDropdown = require("../mapFunctions/dataViewDropdown");
        var columns = e.data.currentData;
        DataViewDropdown.updateLegendColumns(columns, "particulates-opportunity");
      },
    );
  };

  return {
    loadLayerListenersForMap,
  };
};

module.exports = ParticulatesOpportunityLayer();

const MapFunctions = require("../mapFunctions/mapFunctions");
const Tree = require("../../tree");
const Table = require("../mapFunctions/table");
const Layers = require("../mapFunctions/layers");
const TelrLayerFunctions = require("./telrLayerFunctions");
